import { ajax } from "../../../utils/async";
import { getFileExtension, isNullOrEmpty } from "../../../utils/string";
import { GltfMeshExport } from "./GltfMeshExport";
import { GltfMeshImport } from "./GltfMeshImport";
export class GltfMesh {
    /**
     * Imports a gltf file (.gltf or .glb) from an url.
     */
    static ImportFromUrl(pUrl, pScene) {
        if (isNullOrEmpty(pUrl))
            return (Promise.resolve(null));
        if (getFileExtension(pUrl).toLowerCase() === GltfMesh.BINARY_GLTF_EXTENSION) {
            //binary gltf
            const tPromise = GltfMeshImport.LoadArrayBuffer(pUrl).then((pBuffer) => {
                const tRuntime = new GltfMeshImport(pScene);
                return (tRuntime.importBinaryGltf(pBuffer));
            });
            return (tPromise);
        }
        else {
            const tPromise = ajax("GET", pUrl).then((pResponse) => {
                const tRuntime = new GltfMeshImport(pScene);
                return (tRuntime.importGltf(JSON.parse(pResponse), pUrl));
            });
            return (tPromise);
        }
    }
    /**
     * Imports a binary gltf (.glb) given as an ArrayBuffer.
     */
    static Import(pBuffer, pScene) {
        if (pBuffer == null)
            return (null);
        const tRuntime = new GltfMeshImport(pScene);
        return (tRuntime.importBinaryGltf(pBuffer));
    }
    /**
     * Exports the given mesh as a binary gltf (.glb)
     */
    static Export(pMesh) {
        if (pMesh == null || pMesh.geometry == null)
            return (null);
        return (new GltfMeshExport(pMesh).exportMesh());
    }
}
GltfMesh.GLTF_MIME_TYPE = "model/gltf+json";
GltfMesh.GLTF_EXTENSION = ".gltf";
GltfMesh.BINARY_GLTF_MIME_TYPE = "model/gltf.binary";
GltfMesh.BINARY_GLTF_EXTENSION = ".glb";
//// internal //////////////////////////////////////////////////////////////////////////////
/** @internal */
GltfMesh._GLTF_HEADER_MAGIC = 0x46546C67; //Uint32Array value for "glTF"
/** @internal */
export var GltfTypes;
(function (GltfTypes) {
    /** @internal */
    GltfTypes.ComponentType = {
        BYTE: 5120,
        UNSIGNED_BYTE: 5121,
        SHORT: 5122,
        UNSIGNED_SHORT: 5123,
        UNSIGNED_INT: 5125,
        FLOAT: 5126
    };
})(GltfTypes || (GltfTypes = {}));
